import flags from 'react-phone-number-input/flags'

export const languageFlagMapping: Record<string, any> = {
  fr: flags.FR,
  en: flags.GB,
}

export const languageLabelMapping: Record<string, string> = {
  fr: 'Français',
  en: 'English',
}
